export const DURATION_OF_USE = {
  'less-than-month': 'Меньше месяца',
  'month-half-of-year': 'От месяца до полугода',
  'half-of-year-one-year': 'От полугода до года',
  'more-than-year': 'Больше года',
};

export type DurationOfUseType = keyof typeof DURATION_OF_USE;

export const APP_MAIN_ID = 'app-main';
export const BRAND_CHARACTERISTICS_KEY = '06575';
export const HIDE_CALCULATOR_INTERNAL_ID = 'hide_calculator';
export const HIDE_BRANDS_INTERNAL_ID = 'hide_brands';
export const IMAGE_FALL_BACK_URL =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1721381863/fudzi/navigation-microfronts/nophoto.svg/nophoto.svg';
export const HIDE_BOX_M2_SUGGEST_ID = 'hide_box_m2_suggest';

export const REVIEW_FORM_MAX_TEXT_LENGTH = 1500;

export const ENABLE_SERVICES_DISCOUNT = 'enable_services_discount';

export const REMOTE_TIMEOUT_DEFAULT = 2000;

export const DISABLE_LOYALTY_REWARDS_EXPERIMENT = 'loyalty_rewards_disable_pdp';
